import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { getReports } from '../utils/api';

const NAVY = '#0d2137';
const GREEN = '#1a6b3c';

function fmt(d) { return d.toISOString().split('T')[0]; }

function getRange(tab) {
  const now = new Date();
  if (tab === 'all') return { from: '2020-01-01', to: fmt(now) };
  if (tab === 'today') return { from: fmt(now), to: fmt(now) };
  if (tab === 'week') {
    const day = now.getDay();
    const mon = new Date(now); mon.setDate(now.getDate() - (day === 0 ? 6 : day - 1));
    return { from: fmt(mon), to: fmt(now) };
  }
  if (tab === 'month') {
    return { from: now.getFullYear() + '-' + String(now.getMonth()+1).padStart(2,'0') + '-01', to: fmt(now) };
  }
  return null;
}

export default function Reports() {
  const [tab, setTab] = useState('all');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = (f, t) => {
    if (!f || !t) return;
    setLoading(true);
    getReports(f, t)
      .then(r => setData(r.data))
      .catch(() => toast.error('Failed to load reports'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (tab !== 'custom') {
      const r = getRange(tab);
      setFrom(r.from); setTo(r.to);
      load(r.from, r.to);
    }
  }, [tab]);

  const tabs = [
    { key: 'all', label: 'All' },
    { key: 'today', label: 'Today' },
    { key: 'week', label: 'This Week' },
    { key: 'month', label: 'This Month' },
    { key: 'custom', label: 'Custom Range' },
  ];

  const s = data ? data.summary : {};

  return (
    <div style={{ padding: '32px 28px' }}>
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ color: NAVY, fontSize: 26, fontWeight: 900, marginBottom: 4 }}>Reports</h1>
        <div style={{ color: '#64748b', fontSize: 14 }}>Visits and Payments summary</div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        {tabs.map(function(t) { return (
          <button key={t.key} onClick={function(){ setTab(t.key); }} style={{
            padding: '8px 20px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 700,
            background: tab === t.key ? NAVY : '#e2e8f0',
            color: tab === t.key ? '#fff' : '#475569',
          }}>{t.label}</button>
        ); })}
      </div>

      {tab === 'custom' && (
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 20, flexWrap: 'wrap' }}>
          <label style={{ fontSize: 13, fontWeight: 600, color: NAVY }}>From</label>
          <input type="date" value={from} onChange={function(e){ setFrom(e.target.value); }}
            style={{ padding: '8px 12px', border: '1.5px solid #cbd5e1', borderRadius: 8, fontSize: 14, color: NAVY }} />
          <label style={{ fontSize: 13, fontWeight: 600, color: NAVY }}>To</label>
          <input type="date" value={to} onChange={function(e){ setTo(e.target.value); }}
            style={{ padding: '8px 12px', border: '1.5px solid #cbd5e1', borderRadius: 8, fontSize: 14, color: NAVY }} />
          <button onClick={function(){ load(from, to); }} style={{ padding: '9px 22px', background: NAVY, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 700 }}>
            {loading ? 'Loading...' : 'Search'}
          </button>
        </div>
      )}

      {data && !loading && (
        <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 20 }}>
          Showing: <b style={{ color: NAVY }}>{data.from}</b> to <b style={{ color: NAVY }}>{data.to}</b>
        </div>
      )}

      {loading && <div style={{ textAlign: 'center', padding: 60, color: '#94a3b8' }}>Loading...</div>}

      {data && !loading && (
        <React.Fragment>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 32 }}>

            <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.07)', overflow: 'hidden', border: '2px solid ' + NAVY }}>
              <div style={{ background: NAVY, padding: '14px 20px', color: '#fff' }}>
                <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase', opacity: 0.7 }}>Total Visits</div>
                <div style={{ fontSize: 38, fontWeight: 900, marginTop: 4 }}>{s.visits || 0}</div>
                <div style={{ fontSize: 13, opacity: 0.8 }}>All registered visits</div>
              </div>
              <div style={{ padding: 20 }}>
                {data.doctor_wise && data.doctor_wise.map(function(d, i) { return (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: i < data.doctor_wise.length - 1 ? '1px solid #f1f5f9' : 'none' }}>
                    <div>
                      <div style={{ fontWeight: 700, color: NAVY, fontSize: 13 }}>{d.doctor_name || 'Unknown'}</div>
                      <div style={{ fontSize: 11, color: '#94a3b8' }}>{d.specialty || '—'}</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontWeight: 800, color: NAVY, fontSize: 18 }}>{d.visits}</div>
                      <div style={{ fontSize: 11, color: '#64748b' }}>visits</div>
                    </div>
                  </div>
                ); })}
                {(!data.doctor_wise || data.doctor_wise.length === 0) && (
                  <div style={{ color: '#94a3b8', fontSize: 13, textAlign: 'center', padding: 20 }}>No data</div>
                )}
              </div>
            </div>

            <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.07)', overflow: 'hidden', border: '2px solid ' + GREEN }}>
              <div style={{ background: GREEN, padding: '14px 20px', color: '#fff' }}>
                <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase', opacity: 0.7 }}>Payments Received</div>
                <div style={{ fontSize: 38, fontWeight: 900, marginTop: 4 }}>{s.payments || 0}</div>
                <div style={{ fontSize: 15, fontWeight: 800 }}>PKR {Number(s.payments_total || 0).toLocaleString()}</div>
              </div>
              <div style={{ padding: 20 }}>
                {data.doctor_wise && data.doctor_wise.map(function(d, i) { return (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: i < data.doctor_wise.length - 1 ? '1px solid #f1f5f9' : 'none' }}>
                    <div>
                      <div style={{ fontWeight: 700, color: NAVY, fontSize: 13 }}>{d.doctor_name || 'Unknown'}</div>
                      <div style={{ fontSize: 11, color: '#94a3b8' }}>{d.paid_visits} paid visits</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontWeight: 800, color: GREEN, fontSize: 14 }}>PKR {Number(d.paid_total).toLocaleString()}</div>
                    </div>
                  </div>
                ); })}
                {(!data.doctor_wise || data.doctor_wise.length === 0) && (
                  <div style={{ color: '#94a3b8', fontSize: 13, textAlign: 'center', padding: 20 }}>No payments</div>
                )}
              </div>
            </div>
          </div>

          {data.daily_trend && data.daily_trend.length > 0 && (
            <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.07)', overflow: 'hidden' }}>
              <div style={{ padding: '16px 20px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontWeight: 800, color: NAVY, fontSize: 16 }}>Daily Detail</div>
                <div style={{ fontSize: 12, color: '#94a3b8' }}>{data.daily_trend.length} days</div>
              </div>
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ background: '#f8fafc' }}>
                      {['Date', 'Visits', 'Paid', 'Amount Collected'].map(function(h) { return (
                        <th key={h} style={{ padding: '10px 16px', fontSize: 12, fontWeight: 700, textAlign: 'left', color: NAVY, borderBottom: '2px solid #e2e8f0' }}>{h}</th>
                      ); })}
                    </tr>
                  </thead>
                  <tbody>
                    {data.daily_trend.map(function(d, i) { return (
                      <tr key={i} style={{ borderBottom: '1px solid #f1f5f9', background: i % 2 === 0 ? '#fff' : '#f8fafc' }}>
                        <td style={{ padding: '10px 16px', fontWeight: 600, color: NAVY }}>{d.date}</td>
                        <td style={{ padding: '10px 16px', fontWeight: 700 }}>{d.visits}</td>
                        <td style={{ padding: '10px 16px', fontWeight: 700, color: Number(d.paid_total) > 0 ? GREEN : '#94a3b8' }}>
                          {Number(d.paid_total) > 0 ? '✓ Yes' : '—'}
                        </td>
                        <td style={{ padding: '10px 16px', fontWeight: 800, color: Number(d.paid_total) > 0 ? GREEN : '#94a3b8' }}>
                          {Number(d.paid_total) > 0 ? 'PKR ' + Number(d.paid_total).toLocaleString() : 'PKR 0'}
                        </td>
                      </tr>
                    ); })}
                  </tbody>
                  <tfoot>
                    <tr style={{ background: NAVY, color: '#fff' }}>
                      <td style={{ padding: '12px 16px', fontWeight: 800 }}>TOTAL</td>
                      <td style={{ padding: '12px 16px', fontWeight: 800 }}>{s.visits || 0} visits</td>
                      <td style={{ padding: '12px 16px', fontWeight: 800 }}>{s.payments || 0} paid</td>
                      <td style={{ padding: '12px 16px', fontWeight: 800, color: '#86efac' }}>PKR {Number(s.payments_total || 0).toLocaleString()}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
}
